module.exports = __webpack_public_path__ + "static/img/payroll.34cbab7.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/payroll.svg
// module id = g0Fw
// module chunks = 4